<template>
  <div class="carousel">
    <transition @enter="enter" @leave="leave" mode="out-in">
      <figure
        class="carousel__cont"
        :key="currentIndex"
      >
        <div
          class="carousel__image image--prev"
          :style="{
            backgroundImage: `url(${speakers[(currentIndex === 0 ? (speakers.length - 1) : currentIndex - 1)].pictureUrl})`,
            transform: `translateX(-${getTranslate()}px)`,
            opacity: 0,
          }"
        ></div>
        <div
          class="carousel__image image--current"
          :style="{ backgroundImage: `url(${speakers[currentIndex].pictureUrl})` , transform : isMobile() ? 'rotate(-5deg)' : false }"
        ></div>
        <div
          class="carousel__image image--next"
          :style="{
            backgroundImage: `url(${speakers[currentIndex === (speakers.length - 1) ? 0 : currentIndex + 1].pictureUrl})`,
            transform: `translateX(${getTranslate()}px)`,
            opacity: 0,
          }"
        ></div>
      </figure>
    </transition>
  </div>
</template>

<script>
import anime from 'animejs';
import { qs, isMobile } from '@/scripts/utils';


export default {
  name: 'speakerCarousel',

  props: {
    currentIndex: {
      type: Number,
      required: true,
    },

    speakers: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      dir: '',
      isMobile,
    };
  },

  watch: {
    currentIndex(newVal, oldVal) {
      this.dir = newVal > oldVal ? newVal === this.speakers.length -1 && oldVal === 0 ? 'prev' : 'next' : newVal === 0 && oldVal === this.speakers.length -1 ? 'next' :'prev';
    },
  },

  methods: {
    clicktToSpeaker(url) {
      this.$store.commit('SET_STATE_LOADER', true);

      this.$router.push(url);
    },

    getTranslate() {
      const translate = this.$el === undefined ? 500 : this.$el.getBoundingClientRect().width + 100;

      return translate;
    },

    enter(el, done) {
      if (isMobile()) {
        const current = qs('.image--current', el);

        anime({
          targets: current,
          duration: 0,
          rotateZ: '-5deg',
        });
      }
      done();
    },

    leave(el, done) {
      const tX = this.dir === 'prev' ? 1 : -1;
      const tXm = this.dir === 'prev' ? -1 : 1;
      const current = qs('.image--current', el);
      const move = this.dir === 'prev' ? qs('.image--prev', el) : qs('.image--next', el);

      const basicTimeline = anime.timeline();

      basicTimeline.add({
        targets: current,
        duration: 1000,
        opacity: [1, 0],
        translateX: [0, this.getTranslate() * tX],
        rotateZ: isMobile() ? ['-5deg', '0deg'] : ['0deg', `${tX * 5}deg`],
        easing: 'easeInOutSine',
        offset: 0,
      })
        .add({
          targets: move,
          duration: 800,
          translateX: [this.getTranslate() * tXm, 0],
          rotateZ: isMobile() ? ['5deg', '-5deg'] : [`${tX * 5}deg`, '0deg'],
          easing: [0.25, 0.87, 0.43, 1],
          offset: 400,
          opacity: [0, 1],
        });

      basicTimeline.finished.then(() => {
        done();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/utils";

.carousel {
  position: relative;
  width: 100%;
  max-width: 180px;

  @include mq(mobile) {
    max-width: 210px;
  }

  @include mq(ipadP) {
    max-width: none;
  }

  &__cont {
    position: relative;

    @include aspect-ratio(3, 4);
  }

  &__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;

    will-change: transform;
    backface-visibility: hidden;
    transform-style: preserve-3d;
  }
}
</style>
